/**
 * Classificadores puros de resposta de erro da API.
 *
 * `isMissingTokenResponse`: identifica o 403 "Token não fornecido/informado"
 * que backends antigos retornam quando a request sai sem Authorization
 * (semanticamente é um 401 — credencial ausente). O api.ts normaliza esse
 * caso para 401 para reaproveitar o fluxo de refresh + retry existente,
 * em vez de falhar de forma irrecuperável no cold-start do embedded.
 */

const MISSING_TOKEN_PATTERNS = [
	"token não fornecido",
	"token nao fornecido",
	"token não informado",
	"token nao informado",
];

export function isMissingTokenResponse(
	status: number,
	data: unknown,
): boolean {
	if (status !== 403) return false;
	if (!data || typeof data !== "object") return false;

	const d = data as Record<string, unknown>;
	const text = [d.error, d.msg, d.message]
		.filter((v): v is string => typeof v === "string")
		.join(" ")
		.toLowerCase();

	return MISSING_TOKEN_PATTERNS.some((p) => text.includes(p));
}
